import React from "react";
import { Card } from "react-bootstrap";

/**
 * @typedef {Object} KpiProps
 * @property {string} label
 * @property {string} value
 * @property {string} [delta]
 * @property {string} icon
 * @property {string} tone
 */

/**
 * @param {KpiProps} props
 */

export function Kpi({ label, value, delta, icon, tone = "primary" }) {
  const positive = delta?.trim().startsWith("+");
  return (
    <Card className="pbi-kpi h-100">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="pbi-kpi-label">{label}</div>
            <div className="pbi-kpi-value">{value}</div>
            {delta && (
              <div className={`pbi-kpi-delta ${positive ? "up" : "down"}`}>
                <i
                  className={`bi ${positive ? "bi-arrow-up-right" : "bi-arrow-down-right"}`}
                />{" "}
                {delta}
              </div>
            )}
          </div>
          <div className={`pbi-kpi-icon tone-${tone}`}>
            <i className={`bi ${icon}`} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
